import { includes } from 'ramda';

import {
  PATH_INVOICE_CLONE,
  PATH_INVOICE_EDIT,
  PATH_INVOICE_SHOW,
  PATH_INVOICE,
  PATH_LANDING,
  PATH_NEW_REGISTRATION,
  PATH_PRICELIST,
  PATH_SIGNIN_LOGIN,
} from '~/router';

const hiddenPaths = [
  PATH_INVOICE_CLONE,
  PATH_INVOICE_EDIT,
  PATH_INVOICE_SHOW,
  PATH_INVOICE,
  PATH_LANDING,
  PATH_NEW_REGISTRATION,
  PATH_PRICELIST,
  PATH_SIGNIN_LOGIN,
];

export const hideSubnavigationLinks = () => {
  const element = document.getElementById('sub_navigation_links');
  if (element) {
    element.classList.add('hidden');
  }
};

export const showSubnavigationLinks = () => {
  const element = document.getElementById('sub_navigation_links');
  if (element) {
    element.classList.remove('hidden');
  }
};

export const hideContentLinks = () => {
  const element = document.getElementById('content_links');
  if (element) {
    element.classList.add('hidden');
  }
};

export const showContentLinks = () => {
  const element = document.getElementById('content_links');
  if (element) {
    element.classList.remove('hidden');
  }
};

export const hideAppLinks = () => {
  const element = document.getElementById('app_links');
  if (element) {
    element.classList.add('hidden');
  }
};

export const showAppLinks = () => {
  const element = document.getElementById('app_links');
  if (element) {
    element.classList.remove('hidden');
  }
};

export const hideInvoicesInfo = () => {
  const element = document.getElementById('invoices_info');
  if (element) {
    element.classList.add('hidden');
  }
};

export const handleSubnavigationLinks = (show) => {
  show ? showSubnavigationLinks() : hideSubnavigationLinks();
};

export const handleContentLinks = (show) => {
  show ? showContentLinks() : hideContentLinks();
};
export const handleAppLinks = (show) => {
  show ? showAppLinks() : hideAppLinks();
};

const handleFooter = (vueInstance, route) => {
  const store = vueInstance.$store;
  const isAuthorized = store.getters['auth/isAuthorized'];
  const preventedPath = includes(route.name, hiddenPaths);

  handleSubnavigationLinks(isAuthorized && !preventedPath);
  handleContentLinks(!isAuthorized && !preventedPath);
  handleAppLinks(!isAuthorized && !preventedPath);
};

export default handleFooter;
